import { useAtom } from "jotai";
import { userSavedPlacesAtom } from "./atoms";

export function useSavedPlaces() {
  const [{ data, error, isLoading, isFetching, refetch }] =
    useAtom(userSavedPlacesAtom);
  return {
    data,
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
